import { GetCallResponse } from '@distribute/shared/api-types/call';

export const filterByPersonalCalls = (
  calls: GetCallResponse[],
  userId: string
) => calls.filter((call) => call.userToTeam.user.id === userId);

export const filterByTeamCalls = (calls: GetCallResponse[], userId: string) =>
  calls.filter((call) => !call.isPrivate && call.userToTeam.user.id !== userId);
